module.exports = __webpack_public_path__ + "img/icon-excel.83735c27.png";